import React, { useEffect, useRef, useState } from 'react';


import { CollectionReference, collection } from 'firebase/firestore';
import { useFirestore, useFirestoreCollectionData } from 'reactfire';
import { IDatabaseLineItem } from './LineItemDBCreationToolPage';
import { observer } from 'mobx-react';
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import SharedUtils from '../../shared/common/SharedUtils';
import { logDebug } from '../../shared/common/logger';
import LoadingAnimation from '../../components/ui/utils/LoadingAnimation';
import { IExtractionValue, IHeatmapData } from '../../shared/common/Azure';
import PrivateUtils from '../../utils/PrivateUtils';
import MappingUtils, { getMappingStore, ILinkValue } from './MappingTool/utils/MappingUtils';


const InternalMappingToolPage: React.FC = observer(() => {
	const mappingStore = getMappingStore();
	const firestoreToolsCollectionRef = collection(useFirestore(), SharedUtils.getDbPath('tools')) as CollectionReference<IDatabaseLineItem>;
	const lineItemsDataFromDataBase = useFirestoreCollectionData<IDatabaseLineItem>(firestoreToolsCollectionRef, { idField: 'id' });
	const [selectedLineItem, setSelectedLineItem] = useState<IDatabaseLineItem | null>(null);

	const [textAreaValue, setTextAreaValue] = useState(['r-15', 'r-19', 'r', 'replace', 'r+r', 'rem', '4"', '6 inches'].join('\n'));
	const [inputValue, setInputValue] = useState('');
	const [connectedValue, setConnectedValue] = useState<any>();
	const [outputValue, setOutputValue] = useState<string>();
	const [keyElements, setKeyElements] = useState<number[]>([]);
	const [overTuple, setOverTuple] = useState<[number, number]>([-1, -1]);
	const [selectedTuple, setSelectedTuple] = useState<[number, number]>([-1, -1]);
	const [showTable, setShowTable] = useState(true)
	const [searchLineItemInput, setSearchLineItemInput] = useState('');
	const [imageIndexToShow, setImageIndexToShow] = useState(-1);
	const [candidates, setCandidates] = useState<string[]>([]);
	const [showOnlyType, setShowOnlyType] = useState('');
	const [filterNumbers, setFilterNumbers] = useState(false);
	const templateTableRef = useRef<HTMLDivElement>(null);
	// return <div>
	// 	{
	// 		Object.entries(heatmapData).map(([key, values]) => {
	// 			return <div>
	// 				<strong>{key}</strong>
	// 				<div className='flex w-full overflow-x-scroll '>
	// 					{
	// 						values.map((v) => {
	// 							return <div className='flex flex-col'>
	// 								<div className='flex'>
	// 									<div className='flex h-12 w-64 border border-blue-300'>
	// 										{v.template}
	// 									</div>
	// 									<div className='flex h-12 w-64 border border-blue-300'>
	// 										{v.azure}
	// 									</div>
	// 								</div>
	// 								<img className='h-12 border border-blue-300' src={`data:image/png;base64,${v.region64}`} />
	// 							</div>
	// 						})
	// 					}
	// 				</div>
	// 			</div>
	// 		})
	// 	}
	// 	{/* <img className='h-12 border border-blue-300' src={`data:image/png;base64,${imageAsBase64String}`} /> */}
	// </div>


	useEffect(() => {
		mappingStore.loadData(false,true,'Type1');
	}, []);


	useEffect(() => {
		if (selectedTuple[0] < 0) return;
		// let candidates = SharedUtils.removeDuplicateAndEmpty(mappingStore.templateData?.rows[selectedTuple[0]]?.cellTuples[selectedTuple[1]]?.meta?.heatmapData?.map((_v, ind) => {
		// 	const v = SharedUtils.clone(_v) as IHeatmapData;
		// 	const template = [
		// 		v.template[0].toLowerCase().replace(/\s/g, ' ').split(' '),
		// 		v.template[1].toLowerCase().replace(/\s/g, ' ').split(' ')
		// 	];
		// 	v.words[0] = v.words[0].filter((w) => !template[0].includes(w.word.toLowerCase()));
		// 	v.words[1] = v.words[1].filter((w) => !template[1].includes(w.word.toLowerCase()));
		// 	const error = (v.words[0].length + v.words[1].length) === 0;
		// 	const confidence0 = Math.min(...v.words[0].map((w) => w.confidence));
		// 	const confidence1 = Math.min(...v.words[1].map((w) => w.confidence));
		// 	if (confidence0 > 0.8 && confidence1 > 0.8) {
		// 		return [...v.words[0].map(v => v.word), ...v.words[1].map(v => v.word)];
		// 	}
		// 	return [];
		// }).flatMap((v) => v));

		// // remove numbers
		// candidates = candidates.filter((v) => isNaN(Number(v)));
		// setCandidates(candidates);
		// logDebug('candidates:', candidates);
		setSearchLineItemInput(mappingStore.templateData?.rows![selectedTuple[0]]?.cellTuples[selectedTuple[1]]?.cells[0].content || '');
	}, [selectedTuple]);

	const connectInput = async () => {
		if (!selectedLineItem) return;
		if (!textAreaValue.trim()) return;
		const lineItem = selectedLineItem;
		const elements = lineItem.elements;
		const variables = elements.flatMap((element) => {
			if (element.type === 'text') return [];
			return element.acceptableValues;

		}).join('\n');
		if (!variables.length) return;
		const link = await MappingUtils.linkVariablesUsingOpenAI([variables], [textAreaValue], false);
		logDebug("json from openAI", link);
		setConnectedValue(link);
	};


	if (lineItemsDataFromDataBase.status === 'loading' || mappingStore.loadingData) {
		return <div>Loading...
			<LoadingAnimation />
		</div>;
	}



	return <div>
		<button className='absolute bottom-8' onClick={() => setShowTable(v => !v)}>Show</button>
		<div>
			{
				selectedTuple[0] >= 0 &&
				<div>
					<div>
						Selected:
						{
							JSON.stringify([
								Object.entries(mappingStore.templateData?.rows![selectedTuple[0]]?.cellTuples[selectedTuple[1]]?.meta ?? {}).filter(([key, value]) => !key.includes('heatmap')).flatMap(k => k),
								mappingStore.templateData?.rows![selectedTuple[0]]?.cellTuples[selectedTuple[1]]?.cells.map((c) => c?.content || '')]
							)
						}
					</div>
					<div >
						<span>Values:</span>
						<button onClick={() => setShowOnlyType(v => v === 'green' ? '' : 'green')} className='w-32 m-1 p-1 bg-green-200'>{showOnlyType === 'green' ? 'Clear' : 'Only Green'}</button>
						<button onClick={() => setShowOnlyType(v => v === 'yellow' ? '' : 'yellow')} className='w-32 m-1 p-1 bg-yellow-200'>{showOnlyType === 'yellow' ? 'Clear' : 'Only Yellow'}</button>
						<button onClick={() => setFilterNumbers(v => !v)} className='w-32 m-1 p-1 bg-cyan-200'>{filterNumbers ? 'Show Number' : 'Hide Numbers'}</button>
						<div className='h-64 overflow-y-scroll'>
							{
								mappingStore.templateData?.rows![selectedTuple[0]]?.cellTuples[selectedTuple[1]]?.meta?.heatmapData?.map((_v, ind) => {
									const v = SharedUtils.clone(_v) as IHeatmapData;
									const template = [
										v.template[0].toLowerCase().replace(/\s/g, ' ').split(' '),
										v.template[1].toLowerCase().replace(/\s/g, ' ').split(' ')
									];
									v.words[0] = v.words[0].filter((w) => !template[0].includes(w.word.toLowerCase()));
									v.words[1] = v.words[1].filter((w) => !template[1].includes(w.word.toLowerCase()));
									if (filterNumbers) {
										v.words[0] = v.words[0].filter((v) => isNaN(Number(v.word)));
										v.words[1] = v.words[1].filter((v) => isNaN(Number(v.word)));
									}

									const error = v.words[0].length === 0 && v.words[1].length === 0;
									const confidence0 = Math.min(...v.words[0].map((w) => w.confidence));
									const confidence1 = Math.min(...v.words[1].map((w) => w.confidence));
									// logDebug('confidence:', confidence0, confidence1);
									if (showOnlyType === 'green') {
										if (error) return null;
										if (v.words[0].length === 0 && confidence1 < 0.8) return null;
										if (v.words[1].length === 0 && confidence0 < 0.8) return null;
										if (v.words[0].length > 0 && v.words[1].length > 0 && confidence0 < 0.8 && confidence1 < 0.8) return null;
									}
									if (showOnlyType === 'yellow' && (confidence0 >= 0.8 && confidence1 >= 0.8) || error) return null;
									return <div key={ind + '-' + selectedTuple[0] + '-' + selectedTuple[1]}
										className='cursor-pointer' onClick={() => {
											setImageIndexToShow(v => v === ind ? -1 : ind);
										}}>
										<div className='flex'>
											<span className='border border-red-200 w-[300px]'>{JSON.stringify(v.template)}</span>
											<span className='border border-red-200 w-[300px]'>{JSON.stringify(v.azure)}</span>
											<span className='border border-red-200 w-[300px]'
												style={{ backgroundColor: error ? 'rgb(255,200,200)' : confidence0 < 0.8 ? 'yellow' : `rgba(0,255,0,${(confidence0 - 0.8) / 0.2 + 0.1})` }}
											>{JSON.stringify(v.words[0])}</span>
											<span className='border border-red-200 w-[300px]'
												style={{ backgroundColor: error ? 'rgb(255,200,200)' : confidence1 < 0.8 ? 'yellow' : `rgba(0,255,0,${(confidence1 - 0.8) / 0.2 + 0.1})` }}
											>{JSON.stringify(v.words[1])}</span>
											<span className='border border-red-200 w-[300px]'>{v.id}</span>
										</div>
										{
											imageIndexToShow === ind &&
											<img className='h-12 border border-blue-300' src={`data:image/png;base64,${v.region64}`} />
										}
									</div>
								})
							}
						</div>
					</div>
				</div>
			}
		</div>
		<div className='flex'>
			{
				mappingStore.templateData?.rows![selectedTuple[0]]?.cellTuples[selectedTuple[1]]?.meta?.heatMapProcessedData!.candidates?.map((v, ind) => {
					return <div className='p-1 m-2 border border-blue-200' key={ind}
					>
						{v}
					</div>
				})
			}
		</div>
		<br /><br />
		<input className='border border-black' type='text' value={searchLineItemInput} onChange={(e) => setSearchLineItemInput(e.target.value)} />
		<div>
			{
				MappingUtils.filterDatabase(lineItemsDataFromDataBase.data, searchLineItemInput).slice(0, 3).map((lineItem) => {
					return <div key={lineItem.id} className='cursor-pointer'
						onClick={() => {
							setSelectedLineItem(lineItem);
							setSearchLineItemInput('');
						}}
					>
						{
							lineItem.originalLineItem
						}
					</div>
				})
			}
			<div className='bg-red-100'>
				{selectedLineItem?.originalLineItem}
			</div>
		</div>
		<Drawer
			open={showTable}
			onClose={() => setShowTable(false)}
			direction='bottom'
			size={'800px'}
			className='w-[50%] overflow-y-scroll'

		>
			<div className='cursor-pointer' onClick={() => setShowTable(false)}>Close</div>
			<div className='cursor-pointer' onClick={() => PrivateUtils.exportPDFElements([templateTableRef.current!], {
				outname: 'template_heatmap',
				orientation: 'portrait'
			})}>Export PDF</div>
			<div className='flex flex-col' ref={templateTableRef}>
				<table className='bordered-table' >
					{
						MappingUtils.instance().getTableFromTemplate((pair) => { setSelectedTuple(pair), setShowTable(false) },
							setOverTuple, selectedTuple, overTuple, { height: '60px' }
						).map((content, i) => <tbody key={i}>{content}</tbody>)
					}
				</table>
			</div>
		</Drawer>
	</div>


	const workingSet = Object.entries<IExtractionValue[]>(mappingStore.extractionData || {}).filter(([key, values]) => key.includes('seal_prime_key') || key.includes('seal_prime_value')).reverse();
	const keySet = workingSet[0][1].filter((v, i) => [0, 1, 4, 6, 8, 11, 12, 13, 15, 21, 24, 26, 29, 33].includes(i));
	const valueSet = workingSet[1][1].filter((v, i) => [1, 2, 3, 4, 5, 7, 9, 10, 11, 13, 15, 16, 17, 18, 20, 22, 23, 24, 25, 29, 32, 33, 35, 36, 37, 38, 39, 40, 42, 43, 44, 45, 46, 47, 50, 52, 54, 55, 59, 61, 62, 63, 64, 65, 67, 68, 70].includes(i));
	const showOnlyApproved = true;
	const showWorkingSet = true;





	return (
		<div className='flex flex-col'>
			<strong>Possible tic sheet input</strong>
			<div className='flex'>
				<textarea
					className='w-64 h-64 border border-blue-300 p-2'
					value={textAreaValue}
					onChange={(e) => setTextAreaValue(e.target.value)}
				/>
				<div>
					{
						connectedValue && Object.entries<ILinkValue>(connectedValue).map(([key, value]) => {
							let background = value.confidence === 'confident' ? 'bg-green-100' : 'bg-red-100';
							if (value.status === 'approved') background = 'bg-green-400';
							if (value.status === 'not approved') background = 'bg-red-400';
							return <div className='flex items-center'>
								<div className={`w-[300px] border border-blue-100 p-1 ${background}`}>{key}</div>
								<select className={`w-[300px] border border-blue-100 p-1 ${background}`} value={value.variable}
									onChange={(e) => {
										value.variable = e.target.value;
										setConnectedValue({ ...connectedValue });
									}}
								>
									{
										selectedLineItem!.elements.flatMap(e => e.acceptableValues).filter(s => s?.trim()).map((av) => {
											return <option value={av}>{av}</option>
										})
									}
									{/* <option value={value.variable}>{value.variable}</option> */}
								</select>
								<div className='bg-green-200 mx-1 w-4 justify-center flex cursor-pointer select-none'
									onClick={() => {
										value.status = 'approved';
										setConnectedValue({ ...connectedValue });
									}}
								>
									V
								</div>
								<div className='bg-red-200 mx-1 w-4 justify-center flex cursor-pointer select-none'
									onClick={() => {
										value.status = 'not approved';
										setConnectedValue({ ...connectedValue });
									}}
								>
									X
								</div>
							</div>
						})
					}
				</div>
			</div>
			<br />
			<strong>Line Items</strong>
			{

				lineItemsDataFromDataBase.data && lineItemsDataFromDataBase.data.map((lineItem) => {
					return <div className={`border border-red-100 select-none cursor-pointer ${selectedLineItem?.id === lineItem.id ? 'bg-red-100' : ''}`}
						onClick={() => {
							setSelectedLineItem(lineItem);
						}}
					>
						{/* {lineItem.originalLineItem} */}
						<div className='flex items-center'>
							{
								lineItem.elements.map((props, ind) => {
									return <React.Fragment key={ind}>
										{
											props.type === 'text' ?
												<span>{props.value}&nbsp;</span> :
												<><span>
													<div className='bg-cyan-100 flex flex-col'>
														{
															(props.allowEmptyValue ? [...(props.acceptableValues!), '___'] : props.acceptableValues!).map((value, i) => {
																return <React.Fragment key={i}>
																	<span className='border '>{value}</span>
																</React.Fragment>
															})
														}
													</div>
												</span>&nbsp;</>

										}
									</React.Fragment>
								})
							}
						</div>
					</div>
				})
			}
			<br />
			<strong className='bg-green-100 w-16 cursor-pointer'
				onClick={connectInput}
			>
				Connect</strong>
			<br />
			<strong>Test Input</strong>
			<input
				className='w-64 border border-blue-300 px-1'
				value={inputValue}
				onChange={(e) => setInputValue(e.target.value)}
			/>
			<br />
			<strong className='bg-green-100 w-16 cursor-pointer'
				onClick={() => {
					if (!textAreaValue.trim()) return;
					if (!selectedLineItem) return;
					if (!inputValue.trim()) return;
					if (!connectedValue) return;
					const input = ` ${inputValue.replace(/\s/g, ' ')} `;
					const availableValues = textAreaValue.split('\n').map((v) => ` ${v.trim()} `);
					const existingValues = availableValues.filter((v) => input.includes(v)).map((v) => v.trim());
					const existingVariables = existingValues.map((v) => connectedValue[v].variable);
					const output = selectedLineItem.elements.map((element) => {
						if (element.type === 'text') return element.value;
						if (!element.acceptableValues || !element.acceptableValues.length) return element.value;
						const var1 = element.acceptableValues.filter((v) => existingVariables.includes(v));
						// debugger
						if (!var1.length) return element.acceptableValues[0];// default value
						return var1[0];
					}).join(' ');
					setOutputValue(output);
					logDebug("output", output);
				}}
			>
				Test
			</strong>
			<div>{outputValue ?? ''}</div>
			<br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
			{!showOnlyApproved && <div>{JSON.stringify(keyElements)}</div>}
			{
				showWorkingSet && workingSet.map(([key, values], ind) => {
					return <div>
						<strong>{key}</strong>
						<br />
						{
							showOnlyApproved && (ind === 0 ? keySet : valueSet).map((v, ind) => {
								const s = v.value;
								const imageAsBase64String = v.region64;
								return <div className={`flex m-2 items-center cursor-pointer`} >
									{/* <div className='mr-2'>{ind}</div> */}
									<div className='flex h-12 w-64 border border-blue-300'>{'=>'} {v.value}</div>
									<img className='h-12 border border-blue-300' src={`data:image/png;base64,${imageAsBase64String}`} />
								</div>
							})
						}
						{
							!showOnlyApproved && values.map((v: any, ind) => {
								const s = v.value;
								const imageAsBase64String = v.region64;
								return <div className={`flex m-2 items-center cursor-pointer ${keyElements.includes(ind) ? 'bg-green-300' : ''}`} onClick={
									() => {
										if (keyElements.includes(ind)) {
											setKeyElements(keyElements.filter((k) => k !== ind));
										} else {
											setKeyElements([...keyElements, ind]);
										}
									}
								}>
									{/* <div className='mr-2'>{ind}</div> */}
									<div className='flex h-12 w-64 border border-blue-300'>{'=>'} {v.value}</div>
									<img className='h-12 border border-blue-300' src={`data:image/png;base64,${imageAsBase64String}`} />
								</div>
							})
						}
						<br /><br />
					</div>
				})
			}

		</div>
	);
});
export default InternalMappingToolPage;